module.exports = __webpack_public_path__ + "static/media/sonne.40514466.png";